import { getBaseUrl } from './baseUrl';

export type UserActivitySurface = 'TECH_DASHBOARD' | 'CUSTOMER_PORTAL' | 'TASK_WORKSPACE';
export type UserActivityPage = { surface: UserActivitySurface; pageKey: string };

export const USER_ACTIVITY_PAGE_EVENT = 'bonzaiq:user-activity-page';

export function setUserActivityPage(page: UserActivityPage): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(USER_ACTIVITY_PAGE_EVENT, { detail: page }));
}

export async function sendUserActivityHeartbeat(input: {
  clientInstanceId: string;
  surface: UserActivitySurface;
  pageKey: string;
  activeSeconds: number;
  timezone: string | null;
}): Promise<void> {
  const base = await getBaseUrl();
  const response = await fetch(`${base}/api/user-activity/heartbeat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
    keepalive: true
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => null) as { error?: string } | null;
    throw new Error(payload?.error || 'User activity could not be recorded');
  }
}
